var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122.88 122.88",
    width: "24px",
    height: "24px",
    fill: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "download-file-square-line") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.25,0H95.63a27.31,27.31,0,0,1,27.25,27.25V95.63a27.31,27.31,0,0,1-27.25,27.25H27.25A27.31,27.31,0,0,1,0,95.63V27.25A27.31,27.31,0,0,1,27.25,0ZM71.59,50.47a3.38,3.38,0,1,1,4.74,4.83L63.48,68a3.4,3.4,0,0,1-4.75,0L46.07,55.48a3.38,3.38,0,1,1,4.74-4.83l7,6.91.07-24.33a3.39,3.39,0,1,1,6.77.05l-.07,24.15,7-7ZM34.48,81.55l.05-13.24a3.39,3.39,0,1,1,6.77.06l0,9.64q20.16,0,40.32,0l0-9.7a3.39,3.39,0,1,1,6.78.06l-.05,13.18h0A3.38,3.38,0,0,1,85,84.78c-15.72,0-31.39,0-47.11,0a3.38,3.38,0,0,1-3.35-3.23ZM95.63,7H27.25A20.35,20.35,0,0,0,7,27.25V95.63a20.35,20.35,0,0,0,20.29,20.29H95.63a20.35,20.35,0,0,0,20.29-20.29V27.25A20.35,20.35,0,0,0,95.63,7Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.e7feebcb52313fba0fb14021a2ecbf57.svg";
export { ForwardRef as ReactComponent };